import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  // Cookies are unreliable cross-origin behind the preview ingress (CORS *),
  // so we rely on Bearer-token auth via localStorage instead.
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("opik_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Attach `?lang=` to GET requests so backend can return translated content.
  // Only for GETs — POST/PUT/DELETE bodies are language-agnostic.
  if ((config.method || "get").toLowerCase() === "get") {
    const stored = (typeof window !== "undefined" && localStorage.getItem("opik_lang")) || "EN";
    const map = { EN: "en", ID: "id", CN: "zh-cn", TH: "th", AR: "ar" };
    const lang = map[stored] || "en";
    if (lang !== "en") {
      config.params = { ...(config.params || {}), lang };
    }
  }
  return config;
});

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export default api;
